import { render, staticRenderFns } from "./ImagemLocal.vue?vue&type=template&id=dfd027a8&scoped=true&lang=pug&"
import script from "./ImagemLocal.vue?vue&type=script&lang=js&"
export * from "./ImagemLocal.vue?vue&type=script&lang=js&"
import style0 from "./ImagemLocal.vue?vue&type=style&index=0&id=dfd027a8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd027a8",
  null
  
)

export default component.exports